/* eslint-disable angular/constant-name */

angular.module("digiexam").constant("QualityStatusEnum",
	Object.freeze({
		NOTVERIFIED: 0,
		VERIFIED: 1,
		JUNK: 2,
	})
);
